<script>
import { onMount } from 'svelte';
import { log, logEvent } from './telemetry.mjs';

export let contents;

onMount(() => log({event:logEvent.CONTENTS, label:contents.queryroot}));
</script>

<main>
<h1>IB Data Science</h1>
{#if contents.rootQuestion}
<div class="rootQuestion">
<h2>{contents.rootQuestion.title}</h2>
<div class="instructions">
{@html contents.rootQuestion.html}
</div>
</div>
{/if}

{#each contents.sections as section, i}
<div class="section">
    <h3>{section.titles.join(' / ')}</h3>
    <ul>
    {#each section.questions as page, j}
        <li><a href="#/{page.slug}"><span class="num">{i+1}.{j+1}</span> <span class="title">{page.title}</span></a></li>
    {/each}
    </ul>
</div>
{/each}
</main>

<style>
main {
    max-width: 40em;
    margin: 0 auto;
}
div.section {
    font-size: 1rem;
    font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-seri;
}
h2 { 
    margin-top: 1em;
    margin-bottom: 0.5em;
    font-size: 1.5em;
    color: #373636;  
}
h3 {
    font-size: 1em;
    font-weight: 700;
    color: #373636;
    line-height: 1.5em;
    margin-bottom: 1em;
    padding-bottom: 0.5em;
    border-bottom: 1pt solid #ebebeb;
    margin-top: 1.7em;
}
ul {
    position: relative;
    padding: 0;
    margin-bottom: 2pt;
    list-style-type: none;
    columns: 2;
}
@media (max-width: 41em) {
    main { margin-left: 1em; max-width: auto; }
    ul { columns: 1; }
}

li {
    font-size: 1em;
    line-height: 1.4em;
    font-weight: 400;
}
li .num { 
    position: absolute;
    left: 0;
    font-size: 75%;
    line-height: 1em;
    top: 0.5em;
    font-family: Consolas,Lucida Console,Menlo,Monaco,monospace;
    color: #373636;
}
li .title {
    position: relative;
    left: 2.4em;
}
li a, .instructions :global(a) {
    color: rgb(0, 89, 178);
    text-decoration: none;
    border: none;
}
.instructions {
    font-size: 1rem;
    font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-seri;
}
</style>